define('webui-base/js/util/main', ['require', 'exports', 'module', 'webui-base/js/util/misc', 'webui-base/js/util/ajax', 'webui-base/js/util/alerts', 'webui-base/js/util/auth', 'webui-base/js/util/chart', 'webui-base/js/util/cookie', 'webui-base/js/util/data-grid', 'webui-base/js/util/dialog', 'webui-base/js/util/error-boundary', 'webui-base/js/util/feed', 'webui-base/js/util/if-child-has-perm', 'webui-base/js/util/if-perm', 'webui-base/js/util/log', 'webui-base/js/util/message', 'webui-base/js/util/modal', 'webui-base/js/util/net', 'webui-base/js/util/pdf', 'webui-base/js/util/route', 'webui-base/js/util/signal-bus', 'webui-base/js/util/ui'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI = exports.SignalBus = exports.Route = exports.Pdf = exports.Net = exports.Modal = exports.Message = exports.Log = exports.IfPerm = exports.IfChildHasPerm = exports.Feed = exports.ErrorBoundary = exports.Dialog = exports.DataGrid = exports.Cookie = exports.Chart = exports.Auth = exports.Alerts = exports.Ajax = undefined;

var _misc = require('webui-base/js/util/misc');

Object.keys(_misc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _misc[key];
    }
  });
});

var _ajax = require('webui-base/js/util/ajax');

var _ajax2 = babelHelpers.interopRequireDefault(_ajax);

var _alerts = require('webui-base/js/util/alerts');

var _alerts2 = babelHelpers.interopRequireDefault(_alerts);

var _auth = require('webui-base/js/util/auth');

var _auth2 = babelHelpers.interopRequireDefault(_auth);

var _chart = require('webui-base/js/util/chart');

var _chart2 = babelHelpers.interopRequireDefault(_chart);

var _cookie = require('webui-base/js/util/cookie');

var _cookie2 = babelHelpers.interopRequireDefault(_cookie);

var _dataGrid = require('webui-base/js/util/data-grid');

var _dataGrid2 = babelHelpers.interopRequireDefault(_dataGrid);

var _dialog = require('webui-base/js/util/dialog');

var _dialog2 = babelHelpers.interopRequireDefault(_dialog);

var _errorBoundary = require('webui-base/js/util/error-boundary');

var _errorBoundary2 = babelHelpers.interopRequireDefault(_errorBoundary);

var _feed = require('webui-base/js/util/feed');

var _feed2 = babelHelpers.interopRequireDefault(_feed);

var _ifChildHasPerm = require('webui-base/js/util/if-child-has-perm');

var _ifChildHasPerm2 = babelHelpers.interopRequireDefault(_ifChildHasPerm);

var _ifPerm = require('webui-base/js/util/if-perm');

var _ifPerm2 = babelHelpers.interopRequireDefault(_ifPerm);

var _log = require('webui-base/js/util/log');

var _log2 = babelHelpers.interopRequireDefault(_log);

var _message = require('webui-base/js/util/message');

var _message2 = babelHelpers.interopRequireDefault(_message);

var _modal = require('webui-base/js/util/modal');

var _modal2 = babelHelpers.interopRequireDefault(_modal);

var _net = require('webui-base/js/util/net');

var _net2 = babelHelpers.interopRequireDefault(_net);

var _pdf = require('webui-base/js/util/pdf');

var _pdf2 = babelHelpers.interopRequireDefault(_pdf);

var _route = require('webui-base/js/util/route');

var _route2 = babelHelpers.interopRequireDefault(_route);

var _signalBus = require('webui-base/js/util/signal-bus');

var _signalBus2 = babelHelpers.interopRequireDefault(_signalBus);

var _ui = require('webui-base/js/util/ui');

var _ui2 = babelHelpers.interopRequireDefault(_ui);

exports.Ajax = _ajax2.default;
exports.Alerts = _alerts2.default;
exports.Auth = _auth2.default;
exports.Chart = _chart2.default;
exports.Cookie = _cookie2.default;
exports.DataGrid = _dataGrid2.default;
exports.Dialog = _dialog2.default;
exports.ErrorBoundary = _errorBoundary2.default;
exports.Feed = _feed2.default;
exports.IfChildHasPerm = _ifChildHasPerm2.default;
exports.IfPerm = _ifPerm2.default;
exports.Log = _log2.default;
exports.Message = _message2.default;
exports.Modal = _modal2.default;
exports.Net = _net2.default;
exports.Pdf = _pdf2.default;
exports.Route = _route2.default;
exports.SignalBus = _signalBus2.default;
exports.UI = _ui2.default;
});

define('webui-base/js/util/misc', ['require', 'exports', 'module', 'bluebird', 'moment', 'invariant', 'webui-base/js/util/alerts', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postData = exports.REPORT_ACTION = undefined;
exports.getBrandName = getBrandName;
exports.interpolateTemplate = interpolateTemplate;
exports.safeAccess = safeAccess;
exports.safeAccessForDisplay = safeAccessForDisplay;
exports.getFirstDefined = getFirstDefined;
exports.regexpEscape = regexpEscape;
exports.wheelScrollHandler = wheelScrollHandler;
exports.mergeSort = mergeSort;
exports.getCurrentLocationPath = getCurrentLocationPath;
exports.getCurrentLocationSearch = getCurrentLocationSearch;
exports.getCurrentLocation = getCurrentLocation;
exports.getSearchParams = getSearchParams;
exports.appendQueryString = appendQueryString;
exports.getByteLength = getByteLength;
exports.formatDecimal = formatDecimal;
exports.formatCurrency = formatCurrency;
exports.encodeHtml = encodeHtml;
exports.ceilMultiple = ceilMultiple;
exports.formatSplitString = formatSplitString;
exports.formatDatetime = formatDatetime;
exports.getDictValue = getDictValue;
exports.submitFormPage = submitFormPage;
exports.getAppRequire = getAppRequire;
exports.getAutoIncreasedId = getAutoIncreasedId;

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _moment = require('moment');

var _moment2 = babelHelpers.interopRequireDefault(_moment);

var _invariant = require('invariant');

var _invariant2 = babelHelpers.interopRequireDefault(_invariant);

var _alerts = require('webui-base/js/util/alerts');

var _alerts2 = babelHelpers.interopRequireDefault(_alerts);

var langCommon = require('base/lang/' + G.LANG + '/common.json');

function _getDefaultValue(defaultValue) {
  if (typeof defaultValue == 'function') {
    return defaultValue();
  }
  return defaultValue;
}

function getBrandName() {
  return G.BRAND_NAME || 'Kredito';
}

function interpolateTemplate(tpl, data) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!opt.open || !opt.close) {
    opt.open = '{{';
    opt.close = '}}';
  }
  if (opt.open == opt.close) {
    throw new Error('interpolateTemplate: open tag and close tag must not be same!');
  }
  return tpl.split(opt.open).map(function (part, i) {
    if (i === 0) {
      return part;
    }
    var parts = part.split(opt.close);
    var len = parts.length;
    var item = void 0;
    function getDefaultValue() {
      if (typeof opt.defaultValue == 'function') {
        return opt.defaultValue(item.trim());
      } else if (opt.defaultValue != null) {
        return String(opt.defaultValue);
      } else {
        return opt.open + item + opt.close;
      }
    }

    if (len === 1) {
      return opt.open + part;
    } else if (len === 2) {
      item = parts[0];
      return safeAccess(data, item.trim(), getDefaultValue) + parts[1];
    } else {
      item = parts.shift();
      return safeAccess(data, item.trim(), getDefaultValue) + parts.join(opt.close);
    }
  }).join('');
}

function safeAccess(obj, props, defaultValue, canBeNull) {
  if (!obj) {
    return _getDefaultValue(defaultValue);
  }
  if (typeof obj[props] != 'undefined') {
    if (obj[props] === null && !canBeNull) {
      return _getDefaultValue(defaultValue);
    }
    return obj[props];
  }
  props = props.replace(/\[(\w+)\]/g, '.$1');
  props = props.replace(/^\./, '');
  var propsArr = props.split('.');
  for (var i = 0, _l = propsArr.length; i < _l; i++) {
    var k = propsArr[i];
    if (obj && (typeof obj === 'undefined' ? 'undefined' : babelHelpers.typeof(obj)) == 'object' && k in obj && (obj[k] !== null || canBeNull)) {
      obj = obj[k];
    } else {
      return _getDefaultValue(defaultValue);
    }
  }
  return obj;
}

function safeAccessForDisplay(obj, props) {
  var defaultValue = '--';
  var res = props ? safeAccess(obj, props, defaultValue) : obj;
  if (res === '') {
    res = defaultValue;
  }
  if (!['string', 'number', 'boolean'].includes(typeof res === 'undefined' ? 'undefined' : babelHelpers.typeof(res))) {
    res = defaultValue;
  }
  return res + '';
}

function getFirstDefined(obj, keys, evaluator) {
  var argLens = arguments.length;
  var values = null;
  if (argLens === 1) {
    values = obj;
    obj = null;
  } else if (argLens === 2 && typeof keys == 'function') {
    evaluator = keys;
    values = obj;
    obj = null;
    keys = null;
  }
  if (Array.isArray(values)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var val = _step.value;

        if (evaluator) {
          if (evaluator(val)) {
            return val;
          }
        } else if (typeof val != 'undefined') {
          return val;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (obj && Array.isArray(keys)) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        var _val = safeAccess(obj, key);
        if (evaluator) {
          if (evaluator(_val)) {
            return _val;
          }
        } else if (typeof _val != 'undefined') {
          return _val;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
}

function regexpEscape(str) {
  return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}

function wheelScrollHandler(evt) {
  evt.preventDefault();
  var e = evt.originalEvent || evt;
  var step = -30;
  var x = 0;
  var y = 0;
  var top = void 0,
      left = void 0;
  var target = evt.currentTarget;
  if (!isNaN(e.wheelDeltaX)) {
    x = e.wheelDeltaX / 120;
  } else if (!isNaN(e.deltaX)) {
    x = e.deltaX / 120 * -3;
  }
  if (!isNaN(e.wheelDeltaY)) {
    y = e.wheelDeltaY / 120;
  } else if (!isNaN(e.deltaY)) {
    y = e.deltaY / 120 * -3;
  } else if (!isNaN(e.wheelDelta)) {
    y = e.wheelDelta / 120;
  }
  x = x * step;
  y = y * step;
  if (x > 0 && x < 1) {
    x = 1;
  } else if (x < 0 && x > -1) {
    x = -1;
  }
  if (y > 0 && y < 1) {
    y = 1;
  } else if (y < 0 && y > -1) {
    y = -1;
  }
  if (Math.abs(x) > Math.abs(y)) {
    // scroll x
    left = target.scrollLeft + x;
    target.scrollLeft = left;
  } else if (Math.abs(y) > 0) {
    // scroll y
    top = target.scrollTop + y;
    target.scrollTop = top;
  }
}

/**
 * Merge sort (http://en.wikipedia.org/wiki/Merge_sort)
 * https://github.com/mout/mout
 */
function mergeSort(arr, compareFn) {
  if (arr == null) {
    return [];
  } else if (arr.length < 2) {
    return arr;
  }
  if (compareFn == null) {
    compareFn = function defaultCompare(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    };
  }
  var mid = ~~(arr.length / 2);
  var left = mergeSort(arr.slice(0, mid), compareFn);
  var right = mergeSort(arr.slice(mid, arr.length), compareFn);
  var result = [];
  while (left.length && right.length) {
    if (compareFn(left[0], right[0]) <= 0) {
      // if 0 it should preserve same order (stable)
      result.push(left.shift());
    } else {
      result.push(right.shift());
    }
  }
  if (left.length) {
    result.push.apply(result, left);
  }
  if (right.length) {
    result.push.apply(result, right);
  }
  return result;
}

function getCurrentLocationPath() {
  return location.hash.split('?')[0].slice(1);
}

function getCurrentLocationSearch() {
  var res = location.hash.split('?')[1] || '';
  return res && '?' + res;
}

function getCurrentLocation() {
  return getCurrentLocationPath() + getCurrentLocationSearch();
}

function getSearchParams(searchStr) {
  var res = {};
  if (typeof searchStr == 'undefined') {
    searchStr = getCurrentLocationSearch();
  }
  if (!searchStr) {
    return res;
  }
  var pairs = searchStr.replace(/^\?/, '').split('&');
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = pairs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var pair = _step3.value;

      pair = pair.split('=');
      if (pair[0]) {
        res[pair[0]] = decodeURIComponent(pair[1]);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return res;
}

function appendQueryString(url, param, isHashMode) {
  if (!param) {
    param = '';
  } else if ((typeof param === 'undefined' ? 'undefined' : babelHelpers.typeof(param)) == 'object') {
    var tmp = {};
    Object.keys(param).forEach(function (key) {
      var val = param && param[key];
      var type = typeof val === 'undefined' ? 'undefined' : babelHelpers.typeof(val);
      if (val === null) {
        tmp[key] = 'null';
      } else if (type != 'undefined' && type != 'object') {
        tmp[key] = val;
      }
    });
    param = $.param(tmp, true);
  } else if (typeof param == 'string') {
    param = param.replace(/^[&?]/, '');
  } else {
    param = '';
  }
  if (!param) {
    return url;
  }
  if (isHashMode) {
    if (url.indexOf('#') == -1) {
      url += '#' + param;
    } else {
      url += '&' + param;
    }
  } else if (url.indexOf('#') == -1) {
    if (url.indexOf('?') == -1) {
      url += '?' + param;
    } else {
      url += '&' + param;
    }
  } else {
    var _tmp = url.split('#');
    if (_tmp[0].indexOf('?') == -1) {
      url = _tmp[0] + '?' + param + '#' + (_tmp[1] || '');
    } else {
      url = _tmp[0] + '&' + param + '#' + (_tmp[1] || '');
    }
  }
  return url;
}

function getByteLength(str) {
  var res = 0;
  for (var i = 0, _l2 = str.length; i < _l2; i++) {
    var charCode = str.charCodeAt(i);
    if (charCode <= 0x007f) {
      res++;
    } else if (charCode <= 0x07ff) {
      res += 2;
    } else if (charCode <= 0xffff) {
      res += 3;
    } else {
      res += 4;
    }
  }
  return res;
}

function formatDecimal(decimal, digits) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  function formatInteger(integer) {
    var res = [];
    var prefix = '';
    if (integer.indexOf('-') === 0) {
      integer = integer.slice(1);
      prefix = '-';
    }
    var count = 0;
    var arr = integer.split('');
    while (arr.length) {
      if (count && !(count % 3)) {
        res.unshift(opt.integerDevider || (G.LANG == 'id-ID' ? '.' : ','));
      }
      res.unshift(arr.pop());
      count++;
    }
    return prefix + res.join('');
  }
  var res = '';
  decimal += '';
  if (!decimal) {
    return decimal;
  }
  var decimalMatchRes = decimal.match(/^(-?)(\d*)(\.?)(\d*)/) || [];
  res += decimalMatchRes[2];
  if (digits > 0) {
    res += '.';
  } else {
    if (opt.round) {
      res = Math.round(parseFloat(decimal)) + '';
    } else if (opt.ceil) {
      res = Math.ceil(parseFloat(decimal)) + '';
    }
    if (opt.formatInteger !== false) {
      res = formatInteger(res);
    }
    return res;
  }
  var fLen = Math.min(digits > 0 ? digits : 0, 6);
  var dLen = decimalMatchRes[4].length;
  res += decimalMatchRes[4].slice(0, fLen);
  if (fLen > dLen) {
    res += new Array(fLen - dLen + 1).join('0');
  }
  if (dLen > fLen && (opt.round && +decimalMatchRes[4].charAt(fLen) >= 5 || opt.ceil && +decimalMatchRes[4].charAt(fLen) > 0)) {
    return formatDecimal((parseFloat(res) * Math.pow(10, fLen) + 1) / Math.pow(10, fLen), digits);
  }
  if (opt.trimEndZero) {
    res = res.replace(/(\.[1-9]*)0+$/, '$1').replace(/\.$/, '');
  }
  res = res.split('.');
  if (opt.formatInteger !== false) {
    res[0] = formatInteger(res[0]);
  }
  res = res.join('.');
  if (decimalMatchRes[1] && res != '0') {
    res = decimalMatchRes[1] + res;
  }
  return res;
}

function formatCurrency(amount) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (amount == null) {
    return typeof opt.emptyValue != 'undefined' ? opt.emptyValue : safeAccessForDisplay();
  }
  // 脱敏数据直接返回
  if (opt.eyesable) {
    return 'Rp ' + amount;
  }
  var defaultOpt = {
    currency: 'Rp',
    digits: 0,
    ceilMultiple: 0
  };
  opt = Object.assign({}, defaultOpt, opt);
  if (opt.ceilMultiple > 0) {
    amount = ceilMultiple(amount, opt.ceilMultiple);
  }
  var num = formatDecimal(amount, opt.digits >= 0 ? opt.digits : 2, {
    integerDevider: opt.integerDevider,
    ceil: true
  });
  return opt.currency + ' ' + num;
}

function encodeHtml(str) {
  return (str + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/`/g, '&#96;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
}

function ceilMultiple(amount) {
  var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return Math.ceil(amount / multiple) * multiple;
}

function formatSplitString(str) {
  var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
  var tail = arguments[3];

  if (!str) {
    return '';
  }
  var l = str.length - 1;
  return str.split('').map(function (c, i) {
    if (i % gap == gap - 1 && (tail || i != l)) {
      return c + sep;
    } else {
      return c;
    }
  }).join('');
}

function formatDatetime(date, format, fallback) {
  if (!date) {
    return fallback || '';
  }
  if (format === 1) {
    format = langCommon.format.date;
  } else if (format === 2) {
    format = langCommon.format.datetimeWithSeconds;
  }
  var res = (0, _moment2.default)(date).format(format || langCommon.format.datetime);
  if (res == 'Invalid date') {
    res = fallback || '';
  }
  return res;
}

function getDictValue() {
  var dict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments[1];
  var fallback = arguments[2];

  if (fallback == null) {
    fallback = key;
  }
  var item = dict.find(function (item) {
    return key != null && (item.key == key || item.code == key);
  });
  if (!item) {
    return fallback;
  }
  var res = getFirstDefined(item, ['value', 'val', 'name']);
  return res != null ? res : fallback;
}

function submitFormPage(url, data) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_blank';

  var form = $('<form target="' + target + '" action="' + url + '" method="post"></form>').appendTo(document.body);
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = Object.keys(data)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var key = _step4.value;

      form.append($('<input type="hidden" name="' + key + '" value="' + data[key] + '" />'));
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  form[0].submit();
  setTimeout(function () {
    form.remove();
  }, 100);
}

var appRequireMap = {};

function getAppRequire(appName) {
  return appRequireMap[appName] || (appRequireMap[appName] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var req = window.require.extend(G.getRequireConfig(appName));
    if (typeof args[0] == 'string') {
      return req.apply(undefined, args);
    }
    return new _bluebird2.default(function (resolve, reject) {
      req([appName + '/js/amd-v-map'], function (md5map) {
        Object.assign(G.MD5_MAP, md5map);
        req.apply(undefined, args).then(resolve, reject);
      }, function () {
        req.apply(undefined, args).then(resolve, reject);
      });
    });
  });
}

var autoIncreasedId = 0;

function getAutoIncreasedId() {
  return autoIncreasedId++;
}

var REPORT_ACTION = exports.REPORT_ACTION = {
  'SEE': 1,
  'EDIT': 2
};

var routes = Object.fromEntries(Object.entries(langCommon.routes).map(function (item) {
  return item.reverse();
}));

var dealMenuNameToEn = function dealMenuNameToEn(isDetail) {
  var currentActive = $('.app-side-nav__nav .active');
  if (!currentActive) {
    return 'kredito';
  }
  var text = currentActive.find('span').text();
  var isSecondNav = currentActive.hasClass('second-level-nav');
  // 一级菜单
  var firstNav = isSecondNav && routes[currentActive.closest('.first-level-nav').children('a').find('span').text()];
  var target = firstNav ? firstNav + '-' + routes[text] : routes[text];
  var result = isDetail ? target + '-detail' : target;
  return result;
};

/**
* @param {*} data 参数
*/
var postData = function postData(data) {
  var _ref = data || {},
      _ref$isDetail = _ref.isDetail,
      isDetail = _ref$isDetail === undefined ? false : _ref$isDetail,
      _ref$action = _ref.action,
      action = _ref$action === undefined ? REPORT_ACTION.SEE : _ref$action,
      fieldName = _ref.fieldName,
      options = babelHelpers.objectWithoutProperties(_ref, ['isDetail', 'action', 'fieldName']);

  var params = babelHelpers.extends({
    remoteAddress: G.IP['cip'], // 操作人ip
    address: G.IP['cname'], // 操作人地址
    action: action, // 1 查看 2 操作
    isDetail: isDetail,
    catalog: dealMenuNameToEn(isDetail), // 当前页面
    fieldVO: [{ fieldName: fieldName }]
  }, options);
  return params;
};
exports.postData = postData;
});

define('webui-base/js/util/ajax', ['require', 'exports', 'module', 'bluebird', 'md5', 'webui-base/js/util/ui', 'webui-base/js/util/auth', 'webui-base/js/util/alerts', 'webui-base/js/util/misc', 'config', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _md = require('md5');

var _md2 = babelHelpers.interopRequireDefault(_md);

var _ui = require('webui-base/js/util/ui');

var _ui2 = babelHelpers.interopRequireDefault(_ui);

var _auth = require('webui-base/js/util/auth');

var _auth2 = babelHelpers.interopRequireDefault(_auth);

var _alerts = require('webui-base/js/util/alerts');

var _alerts2 = babelHelpers.interopRequireDefault(_alerts);

var _misc = require('webui-base/js/util/misc');

var _config = require('config');

var _config2 = babelHelpers.interopRequireDefault(_config);

var langCommon = require('base/lang/' + G.LANG + '/common.json');


var PROXY_PATH = '/ajax-proxy.html';
var ORIGIN = location.origin || location.protocol + '//' + location.host;
var RES_CODE = {
  ACCOUNT_DENIED: 100102,
  USER_TOKEN_EXPIRED: 100104,
  GUEST_TOKEN_EXPIRED: 100105,
  NEED_LOGIN: 100200,
  DUPLICATE_SUBMIT: -2
};

var postQueue = {};
var proxyQueue = [];
var proxyFrameMap = {};

var loadingCount = 0;

var Ajax = { RES_CODE: RES_CODE };

function url2obj(str) {
  var m = str.match(/([^:]*:)?(?:\/\/)?([^/:]+)?(:)?(\d+)?([^?#]+)(\?[^?#]*)?(#[^#]*)?/);
  m = m || [];
  var uri = {
    href: str,
    protocol: m[1] || 'http:',
    host: (m[2] || '') + (m[3] || '') + (m[4] || ''),
    hostname: m[2] || '',
    port: m[4] || '',
    pathname: m[5] || '',
    search: m[6] || '',
    hash: m[7] || '',
    origin: ''
  };
  uri.origin = uri.protocol + '//' + uri.host;
  return uri;
}

function restartAfterGetNewGuestToken(opt, scheme) {
  _auth2.default.removeToken();
  return new _bluebird2.default(function (resolve, reject) {
    Ajax.get({
      url: 'client/v1/membership/user/init-info',
      _guestTokenRequest: true
    }).then(function (res) {
      if (res.code === 0) {
        _auth2.default.setToken(res.data.token);
        return Ajax[opt._method.toLowerCase()](Object.assign({ _guestTokenRequest: true }, opt), scheme).then(resolve, reject);
      } else {
        var err = new Error(res.msg);
        err.code = res.code;
        reject(err);
      }
    }, reject);
  });
}

function proxyCall(opt, resolve, reject, getXhr) {
  var xhr = void 0,
      pro = void 0;
  var proxyFrame = proxyFrameMap[opt.urlObj.origin];
  if (getXhr) {
    try {
      xhr = new proxyFrame.contentWindow.XMLHttpRequest();
    } catch (e) {
      xhr = new proxyFrame.contentWindow.ActiveXObject('MSXML2.XMLHTTP');
    }
    resolve(xhr);
    return;
  }
  if (opt.type == 'GET') {
    pro = proxyFrame.contentWindow.require('util').Ajax.get(opt);
  } else {
    pro = proxyFrame.contentWindow.require('util').Ajax.post(opt);
  }
  pro.then(function (res) {
    return resolve(res);
  }).catch(function (err) {
    return reject(err);
  }).finally(function () {
    return opt.loading === false || _ui2.default.hideLoading();
  });
}

function proxy(opt, getXhr) {
  var proxyFrame = proxyFrameMap[opt.urlObj.origin];
  if (!proxyFrame) {
    proxyFrame = document.createElement('iframe');
    proxyFrame.style.display = 'none';
    proxyFrame.src = opt.urlObj.origin + PROXY_PATH;
    $(proxyFrame).on('load', function onload(evt) {
      if (proxyFrame._loaded) {
        while (proxyQueue.length) {
          var _proxyQueue$shift = proxyQueue.shift(),
              _opt = _proxyQueue$shift.opt,
              _resolve = _proxyQueue$shift.resolve,
              _reject = _proxyQueue$shift.reject,
              _getXhr = _proxyQueue$shift.getXhr;

          proxyCall(_opt, _resolve, _reject, _getXhr);
        }
      } else {
        $(proxyFrame).off('load', onload).remove();
        proxyFrame = proxyFrameMap[opt.urlObj.origin] = null;
        while (proxyQueue.length) {
          var _proxyQueue$shift2 = proxyQueue.shift(),
              any = _proxyQueue$shift2.reject;

          reject(new Error('Failed to load proxy ' + (opt.urlObj.origin + PROXY_PATH) + '!'));
        }
      }
    });
    var docBody = document.body;
    proxyFrame = proxyFrameMap[opt.urlObj.origin] = docBody.appendChild(proxyFrame);
  }
  var resolve = void 0,
      reject = void 0;
  var pro = new _bluebird2.default(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  if (proxyFrame._loaded) {
    proxyCall(opt, resolve, reject, getXhr);
  } else {
    proxyQueue.push({ opt: opt, resolve: resolve, reject: reject, getXhr: getXhr });
  }
  return pro;
}

Ajax.extendHeaders = function () {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ajax';

  var token = _auth2.default.getToken();
  var ts = new Date().getTime().toString();
  if (type == 'ajax') {
    if (token) {
      headers['Authorization'] = token;
      headers['LPR-TIMESTAMP'] = ts;
      headers['LPR-SIGNATURE'] = (0, _md2.default)((0, _md2.default)(token + ts) + token);
    }
    headers['LPR-PLATFORM'] = 'web';
    headers['LPR-BRAND'] = (0, _misc.getBrandName)();
    headers['Accept-Language'] = G.LANG || 'en-US';
  } else {
    if (token) {
      headers['authorization'] = token;
      headers['_ts'] = ts;
      headers['_signature'] = (0, _md2.default)((0, _md2.default)(token + ts) + token);
    }
    headers['LPR-PLATFORM'] = 'web';
    headers['_brand'] = (0, _misc.getBrandName)();
    headers['language'] = G.LANG || 'en-US';
  }
  return headers;
};

Ajax.getLoadingCount = function () {
  return loadingCount;
};

Ajax.normalizeUrl = function (url) {
  if (url.indexOf('//') === 0) {
    url = location.protocol + url;
  } else if (!/^https?:/.test(url)) {
    url = G.API_BASE + '/' + url.replace(/^\/+/, '');
  }
  return url;
};

Ajax.needLogin = function (code) {
  return [RES_CODE.ACCOUNT_DENIED, RES_CODE.USER_TOKEN_EXPIRED, RES_CODE.NEED_LOGIN].includes(code);
};

Ajax.dealCommonError = function (err) {
  if (err.code === RES_CODE.DUPLICATE_SUBMIT) {
    return;
  } else if (Ajax.needLogin(err.code)) {
    if (window.Skateboard) {
      window.Skateboard.core.destroyAllCache(function (modName) {
        if (modName.indexOf('public/') === 0) {
          return false;
        }
      });
    }
    _auth2.default.removeToken();
    _auth2.default.gotoLogin();
  }
  setTimeout(function () {
    err._caughtByInvoker || _alerts2.default.error(err);
  }, 100);
  throw err;
};

Ajax.setCaught = function (err) {
  err._caughtByInvoker = true;
};

Ajax.getXhr = function (url) {
  url = Ajax.normalizeUrl(url);
  var urlObj = url2obj(url);
  if (!$.support.cors && ORIGIN != urlObj.origin) {
    return proxy({
      url: url,
      urlObj: urlObj
    }, true);
  }
  var xhr = void 0;
  try {
    xhr = new window.XMLHttpRequest();
  } catch (e) {
    xhr = new window.ActiveXObject('MSXML2.XMLHTTP');
  }
  var headers = Ajax.extendHeaders({});
  return _bluebird2.default.resolve({ xhr: xhr, headers: headers });
};

Ajax.get = function (opt, scheme) {
  opt = opt || {};
  opt.type = opt._method = 'GET';
  if (!_auth2.default.getToken() && !opt._guestTokenRequest && (opt._deferGuestToken === false || !_config2.default.DEFER_GUEST_TOKEN)) {
    return restartAfterGetNewGuestToken(opt, scheme);
  }
  opt.url = Ajax.normalizeUrl(opt.url);
  opt.urlObj = opt.urlObj || url2obj(opt.url);
  if (!$.support.cors && ORIGIN != opt.urlObj.origin) {
    opt.dataType = 'jsonp';
  }
  if (opt.dataType == 'jsonp') {
    opt.scriptCharset = opt.scriptCharset || opt.charset || 'UTF-8';
    if (!opt.jsonpCallback) {
      opt.url.split('/').pop().replace(/^[a-zA-Z_]\w*/, function (m) {
        opt.jsonpCallback = '_' + m + '_' + (0, _misc.getAutoIncreasedId)(); // use unique postfix to avoid concurrency issue
        return m;
      });
      opt.jsonpCallback = opt.jsonpCallback || 'jsonpCallback';
    }
    opt.jsonp = opt.jsonp || 'callback';
    opt.data = Ajax.extendHeaders(opt.data || {}, 'jsonp');
  } else {
    opt.headers = Ajax.extendHeaders(opt.headers);
    if (ORIGIN != opt.urlObj.origin) {
      opt.xhrFields = {
        withCredentials: false
      };
    }
  }
  opt.url = (0, _misc.appendQueryString)(opt.url, opt.data);
  delete opt.data;
  var pro = _bluebird2.default.resolve($.ajax(opt));
  loadingCount++;
  opt.loading === false || _ui2.default.showLoading();
  return pro.then(function (res) {
    if (res.code === RES_CODE.GUEST_TOKEN_EXPIRED && !opt._guestTokenRequest) {
      return restartAfterGetNewGuestToken(opt, scheme);
    } else if (res.code !== 0) {
      var err = new Error(res.msg);
      err.code = res.code;
      throw err;
    }
    if (G.ENV == 'local' && scheme) {
      new _bluebird2.default(function (resolve, reject) {
        require(['yom-json-validator'], function (module) {
          resolve(module);
        }, function (err) {
          reject(err);
        });
      }).then(function (validate) {
        var validated = validate(scheme, res);
        log('Validated data with scheme of ' + opt.url);
        log(validated);
      });
    }
    return res;
  }).finally(function () {
    loadingCount--;
    opt.loading === false || _ui2.default.hideLoading();
  }).catch(Ajax.dealCommonError);
};

Ajax.post = function (opt, scheme) {
  opt = opt || {};
  opt.type = opt._method = opt._method || 'POST';
  if (!_auth2.default.getToken() && !opt._guestTokenRequest && (opt._deferGuestToken === false || !_config2.default.DEFER_GUEST_TOKEN)) {
    return restartAfterGetNewGuestToken(opt, scheme);
  }
  opt.dataType = 'json';
  opt.url = Ajax.normalizeUrl(opt.url);
  opt.urlObj = opt.urlObj || url2obj(opt.url);
  if (!$.support.cors && ORIGIN != opt.urlObj.origin) {
    return proxy(opt);
  }
  var data = opt.data || {};
  opt.charset = opt.charset || 'UTF-8';
  if (!opt.notJsonParamData) {
    opt.contentType = 'application/json; charset=' + opt.charset;
    opt.data = typeof data == 'string' ? data : JSON.stringify(data);
  }
  if (ORIGIN != opt.urlObj.origin) {
    opt.xhrFields = {
      withCredentials: false
    };
  }
  opt.url = (0, _misc.appendQueryString)(opt.url, opt.queryString);
  if (G.HOST_INFO && G.HOST_INFO.short) {
    opt.url = (0, _misc.appendQueryString)(opt.url, { short: G.HOST_INFO.short });
  }
  var queueName = opt.queueName == null ? opt.url : opt.queueName;
  if (queueName) {
    if (postQueue[queueName]) {
      var err = new Error(langCommon.msg.duplicateSubmit);
      err.code = RES_CODE.DUPLICATE_SUBMIT;
      return _bluebird2.default.reject(err);
    }
    postQueue[queueName] = 1;
  }
  opt.headers = Ajax.extendHeaders(opt.headers);
  var pro = _bluebird2.default.resolve($.ajax(opt));
  loadingCount++;
  opt.loading === false || _ui2.default.showLoading();
  return pro.then(function (res) {
    if (res.code === RES_CODE.GUEST_TOKEN_EXPIRED && !opt._guestTokenRequest) {
      return restartAfterGetNewGuestToken(opt, scheme);
    } else if (res.code !== 0) {
      var _err = new Error(res.msg);
      _err.code = res.code;
      throw _err;
    }
    if (G.ENV == 'local' && scheme) {
      new _bluebird2.default(function (resolve, reject) {
        require(['yom-json-validator'], function (module) {
          resolve(module);
        }, function (err) {
          reject(err);
        });
      }).then(function (validate) {
        var validated = validate(scheme, res);
        log('Validated data with scheme of ' + opt.url);
        log(validated);
      });
    }
    return res;
  }).finally(function () {
    loadingCount--;
    if (queueName) {
      delete postQueue[queueName];
    }
    opt.loading === false || _ui2.default.hideLoading();
  }).catch(Ajax.dealCommonError);
};

Ajax.put = function (opt) {
  opt = opt || {};
  opt._method = 'PUT';
  return Ajax.post(opt);
};

Ajax.patch = function (opt) {
  opt = opt || {};
  opt._method = 'PATCH';
  return Ajax.post(opt);
};

Ajax.del = Ajax.delete = function (opt) {
  opt = opt || {};
  opt._method = 'DELETE';
  return Ajax.post(opt);
};

exports.default = Ajax;
});

define('webui-base/js/util/alerts', ['require', 'exports', 'module', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var langCommon = require('base/lang/' + G.LANG + '/common.json');

var containerDOM = $('<div class="app-alerts"></div>').appendTo(document.body)[0];
var modal = null;
var toRef = null;

var Alerts = {
  /**
   * @param {String} content
   * @param {Number} timeout ms delay to hide
   * @param {String} type success|info|warning|danger
   */
  show: function show(content) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';

    clearTimeout(toRef);
    this.hide();
    var tpl = '<div class="alert alert-' + type + ' alert-dismissible">\n      <button type="button" class="close" onclick="require(\'util\').Alerts.hide();"><span>&times;</span></button>\n      ' + content + '\n    </div>';
    var dom = $(tpl).appendTo(containerDOM);
    dom[0].offsetTop;
    dom.addClass('show');
    toRef = setTimeout(this.hide, timeout);
    return content;
  },
  hide: function hide() {
    var alerts = $('.alert', containerDOM);
    alerts.removeClass('show');
    setTimeout(function () {
      alerts.remove();
    }, 300);
  },
  getErrMsg: function getErrMsg(content) {
    if ((typeof content === 'undefined' ? 'undefined' : babelHelpers.typeof(content)) == 'object' && content) {
      if (!content.responseJSON && content.responseText) {
        try {
          content = JSON.parse(content.responseText).message;
          if (content) {
            return content;
          }
        } catch (err) {
          log.error(err);
        }
      }
      content = content && (content.status === 200 && langCommon.msg.dataParseErr || content.message || content.responseJSON && content.responseJSON.message || content.responseText || content.statusText) || langCommon.msg.svrErr;
    }
    return content;
  },
  success: function success(content, timeout) {
    return Alerts.show(content, timeout, 'success');
  },
  suc: function suc(content, timeout) {
    return Alerts.success(content, timeout);
  },
  info: function info(content, timeout) {
    return Alerts.show(content, timeout, 'info');
  },
  warning: function warning(content, timeout) {
    return Alerts.show(content, timeout, 'warning');
  },
  warn: function warn(content, timeout) {
    return Alerts.warning(content, timeout);
  },
  danger: function danger(content, timeout) {
    return Alerts.show(content, timeout, 'danger');
  },
  error: function error(content, timeout) {
    if (content instanceof Error) {
      log.error(content);
    }
    return Alerts.danger(Alerts.getErrMsg(content) || langCommon.msg.svrErr, timeout);
  },
  err: function err(content, timeout) {
    return Alerts.error(content, timeout);
  },
  dev: function dev(content, timeout) {
    if ("production" !== 'production') {
      return Alerts.warn('*** ' + content + ' ***', timeout);
    }
    return '';
  }
};

exports.default = Alerts;
});

define('webui-base/js/util/auth', ['require', 'exports', 'module', 'bluebird', 'webui-base/js/util/cookie', 'webui-base/js/util/dialog', 'webui-base/js/util/route', 'webui-base/js/util/signal-bus', 'webui-base/js/util/misc', 'config'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _cookie = require('webui-base/js/util/cookie');

var _cookie2 = babelHelpers.interopRequireDefault(_cookie);

var _dialog = require('webui-base/js/util/dialog');

var _dialog2 = babelHelpers.interopRequireDefault(_dialog);

var _route = require('webui-base/js/util/route');

var _route2 = babelHelpers.interopRequireDefault(_route);

var _signalBus = require('webui-base/js/util/signal-bus');

var _signalBus2 = babelHelpers.interopRequireDefault(_signalBus);

var _misc = require('webui-base/js/util/misc');

var _config = require('config');

var _config2 = babelHelpers.interopRequireDefault(_config);

var USER_LEVEL = (0, _misc.safeAccess)(G.USER_INFO.user, 'Role.level', '');


var PERMISSIONS = G.USER_INFO.permissions || [];

var PERM_VALIDATORS = {
  _deny_all_: function _deny_all_() {
    return false;
  },
  _allow_all_: function _allow_all_() {
    return true;
  },
  _login_: function _login_() {
    return Auth.isLoggedIn();
  },
  _admin_: function _admin_() {
    return Auth.isAdmin();
  },
  _super_admin_: function _super_admin_() {
    return Auth.isSuperAdmin();
  }
};

var Auth = {
  isLoggedIn: function isLoggedIn() {
    return !!this.getToken();
  },
  isAdmin: function isAdmin() {
    return USER_LEVEL == 'admin' || this.isSuperAdmin();
  },
  isSuperAdmin: function isSuperAdmin() {
    return USER_LEVEL == 'superAdmin';
  },
  getToken: function getToken() {
    G.TOKEN = G.TOKEN || localStorage.getItem('token');
    return G.TOKEN;
  },
  setToken: function setToken(token) {
    G.TOKEN = token;
    localStorage.setItem('token', token);
  },
  removeToken: function removeToken() {
    G.TOKEN = null;
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
  },
  logout: function logout() {
    var _this = this;

    return new _bluebird2.default(function (resolve, reject) {
      new _bluebird2.default(function (resolve, reject) {
        require(['action/auth/main'], function (module) {
          resolve(module);
        }, function (err) {
          reject(err);
        });
      }).then(function (_ref) {
        var authActions = _ref.default;

        authActions.logout().then(function () {
          _this.removeToken();
          resolve();
        }, reject);
      }, reject);
    });
  },
  gotoLogin: function gotoLogin() {
    var jump = location.href;
    if (jump.indexOf('/public/login') === -1) {
      _route2.default.push('/public/login', { jump: jump });
    }
  },


  Perm: {
    _has: function _has(perm) {
      if (!perm) {
        return true;
      }
      var param = void 0;
      var parts = perm.split('@');
      if (parts.length > 1) {
        // param@perm
        param = parts[0];
        perm = parts[1];
      }
      if (PERM_VALIDATORS[perm]) {
        return PERM_VALIDATORS[perm](param);
      }
      // if (perm != '_deny_all_') {
      //   return true; // temporarily disable UI perm checking
      // }
      if (Auth.isSuperAdmin()) {
        return true;
      }
      return PERMISSIONS.indexOf(perm) >= 0;
    },
    has: function has(perm, type) {
      var _this2 = this;

      if (Array.isArray(perm)) {
        if (!perm.length) {
          return true;
        } else if (type == 'all') {
          return perm.every(function (p) {
            return _this2._has(p);
          });
        } else {
          return perm.some(function (p) {
            return _this2._has(p);
          });
        }
      } else {
        return this._has(perm);
      }
    },
    redirect: function redirect(direct) {
      if (direct == 'dialog') {
        _dialog2.default.close(0);
        _dialog2.default.open('webui-base:auth/no-perm');
      } else {
        _route2.default.push('/public/no-perm');
      }
    }
  }
};

exports.default = Auth;
});

define('webui-base/js/util/chart', ['require', 'exports', 'module'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colorPalette = ['#5ab1ef', '#8d98b3', '#2ec7c9', '#ffb980', '#d87a80', '#b6a2de', '#e5cf0d', '#97b552', '#95706d', '#dc69aa', '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050', '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'];

var theme = {
  color: colorPalette,

  title: {
    textStyle: {
      fontWeight: 'normal',
      color: '#008acd'
    }
  },

  visualMap: {
    itemWidth: 15,
    color: ['#5ab1ef', '#e0ffff']
  },

  toolbox: {
    iconStyle: {
      normal: {
        borderColor: colorPalette[0]
      }
    }
  },

  tooltip: {
    backgroundColor: 'rgba(0,0,0,0.7)',
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: '#008acd'
      },
      crossStyle: {
        color: '#008acd'
      },
      shadowStyle: {
        color: 'rgba(200,200,200,0.2)'
      }
    }
  },

  dataZoom: {
    dataBackgroundColor: '#efefff',
    fillerColor: 'rgba(182,162,222,0.2)',
    handleColor: '#008acd'
  },

  grid: {
    borderColor: '#eee'
  },

  categoryAxis: {
    axisLine: {
      lineStyle: {
        color: '#008acd'
      }
    },
    splitLine: {
      lineStyle: {
        color: ['#eee']
      }
    }
  },

  valueAxis: {
    axisLine: {
      lineStyle: {
        color: '#008acd'
      }
    },
    splitArea: {
      show: true,
      areaStyle: {
        color: ['rgba(250,250,250,0.1)', 'rgba(200,200,200,0.1)']
      }
    },
    splitLine: {
      lineStyle: {
        color: ['#eee']
      }
    }
  },

  timeline: {
    lineStyle: {
      color: '#008acd'
    },
    controlStyle: {
      normal: { color: '#008acd' },
      emphasis: { color: '#008acd' }
    },
    symbol: 'emptyCircle',
    symbolSize: 3
  },

  line: {
    smooth: true,
    symbol: 'emptyCircle',
    symbolSize: 3
  },

  candlestick: {
    itemStyle: {
      normal: {
        color: '#d87a80',
        color0: '#2ec7c9',
        lineStyle: {
          color: '#d87a80',
          color0: '#2ec7c9'
        }
      }
    }
  },

  scatter: {
    symbol: 'circle',
    symbolSize: 4
  },

  map: {
    label: {
      normal: {
        textStyle: {
          color: '#d87a80'
        }
      }
    },
    itemStyle: {
      normal: {
        borderColor: '#eee',
        areaColor: '#ddd'
      },
      emphasis: {
        areaColor: '#fe994e'
      }
    }
  },

  graph: {
    color: colorPalette
  },

  gauge: {
    axisLine: {
      lineStyle: {
        color: [[0.2, '#2ec7c9'], [0.8, '#5ab1ef'], [1, '#d87a80']],
        width: 10
      }
    },
    axisTick: {
      splitNumber: 10,
      length: 15,
      lineStyle: {
        color: 'auto'
      }
    },
    splitLine: {
      length: 22,
      lineStyle: {
        color: 'auto'
      }
    },
    pointer: {
      width: 5
    }
  }
};

var Chart = {
  theme: theme
};

exports.default = Chart;
});

define('webui-base/js/util/cookie', ['require', 'exports', 'module', 'webui-base/js/util/misc'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _misc = require('webui-base/js/util/misc');

var DOMAIN = document.domain;


var Cookie = {
  set: function set(name, value, domain, path, hour) {
    var expire = void 0;
    if (hour) {
      expire = new Date();
      expire.setTime(expire.getTime() + 3600000 * hour);
    }
    document.cookie = name + '=' + value + '; ' + (expire ? 'expires=' + expire.toGMTString() + '; ' : '') + ('path=' + (path || '/') + '; ') + ('domain=' + (domain || DOMAIN || '') + ';');
  },
  get: function get(name) {
    var r = new RegExp('(?:^|;\\s*)' + (0, _misc.regexpEscape)(name) + '=([^;]*)'),
        m = document.cookie.match(r);
    return m && m[1] || '';
  },
  del: function del(name, domain, path) {
    document.cookie = name + '=; expires=Mon, 26 Jul 1997 05:00:00 GMT; ' + ('path=' + (path || '/') + '; ') + ('domain=' + (domain || DOMAIN || '') + ';');
  }
};

exports.default = Cookie;
});

define('webui-base/js/util/data-grid', ['require', 'exports', 'module', 'react', 'react-dom', 'webui-base/js/util/misc', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

var _misc = require('webui-base/js/util/misc');

var langCommon = require('base/lang/' + G.LANG + '/common.json');


var OP_LIST_CLASS_NAME = 'data-grid-component-op-list';

function initOpList() {
  if ($('.' + OP_LIST_CLASS_NAME).length) {
    return;
  }
  $('<ul class="' + OP_LIST_CLASS_NAME + ' dropdown-menu"></ul>').appendTo(document.body);
  $(document.body).on('click', function (evt) {
    if ($(evt.target).closest('.yom-data-grid-column-__op__').length) {
      return;
    }
    hideOpList();
  });
}

function hideOpList() {
  $('.yom-data-grid-column-__op__ .btn').removeClass('active');
  $('.' + OP_LIST_CLASS_NAME).removeClass('active');
}

function onClickOpBtn(opListContent, evt) {
  initOpList();
  var btn = $(evt.currentTarget);
  if (btn.hasClass('active')) {
    hideOpList();
    return;
  }
  hideOpList();
  btn.addClass('active');
  var offset = btn.offset();
  var opList = $('.' + OP_LIST_CLASS_NAME);
  _reactDom2.default.unmountComponentAtNode(opList[0]);
  _reactDom2.default.render(opListContent, opList[0]);
  opList.css({
    left: offset.left + 'px',
    top: offset.top + btn.height() + 'px'
  }).addClass('active');
}

var DataGrid = {
  getState: function getState(dataGridComponent) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var dgState = null;
    var dataGridInstance = dataGridComponent && dataGridComponent.dataGridInstance;
    if (dataGridInstance) {
      dgState = {
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
        filterMap: dataGridInstance.parseFilterMap(params.filterMap)
      };
    }
    return dgState;
  },
  getQueryUrl: function getQueryUrl(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return (0, _misc.appendQueryString)(url, {
      page: params.page,
      pageSize: params.pageSize,
      sortBy: params.sortBy,
      sortOrder: params.sortOrder,
      filterMap: params.filterMap
    });
  },
  getColumns: function getColumns(columns) {
    return columns.map(this.getColumn);
  },
  getColumn: function getColumn(column) {
    if (column.__standard) {
      return column;
    }
    return babelHelpers.extends({
      titleRenderer: function titleRenderer(cellValue) {
        if (typeof column.title != 'undefined') {
          return column.title;
        } else if (column.renderer) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return column.renderer.apply(column, [(0, _misc.encodeHtml)(cellValue)].concat(args));
        } else if (column.reactRenderer) {
          return '';
        }
        return (0, _misc.safeAccessForDisplay)(cellValue);
      },
      renderer: function renderer(cellValue, rowIndex, rowData) {
        return (0, _misc.safeAccessForDisplay)(cellValue);
      }
    }, column, {
      __standard: 1
    });
  },
  getIdColumn: function getIdColumn(to, column) {
    var toUrl = !to ? '' : window.Skateboard ? window.Skateboard.history.to(to) : '#/' + to;
    return this.getColumn(babelHelpers.extends({
      id: 'id',
      name: 'ID',
      width: 80,
      title: '',
      renderer: function renderer(cellValue, rowIndex, rowData) {
        if (!toUrl) {
          return cellValue;
        }
        return '<a href="' + toUrl + '?id=' + cellValue + '">' + cellValue + '</a>';
      }
    }, column));
  },
  getActionColumn: function getActionColumn(_reactRenderer) {
    return this.getColumn({
      id: '__op__',
      name: '',
      width: 1,
      type: 'form',
      textAlign: 'center',
      reactRenderer: function reactRenderer(cellValue, rowIndex, rowData) {
        var opListContent = _reactRenderer.call(this, cellValue, rowIndex, rowData);
        if (!opListContent || !opListContent.props.children || Array.isArray(opListContent.props.children) && opListContent.props.children.every(function (item) {
          return !item;
        })) {
          return null;
        }
        return _react2.default.createElement(
          'button',
          {
            className: 'btn btn-link',
            ref: function ref(el) {
              $(el).off('click').on('click', onClickOpBtn.bind(null, opListContent));
            }
          },
          _react2.default.createElement('i', { className: 'fa fa-ellipsis-v' })
        );
      }
    });
  },
  getCurrencyColumn: function getCurrencyColumn(column) {
    return this.getColumn(babelHelpers.extends({
      width: 150,
      textAlign: 'right',
      renderer: function renderer(cellValue, rowIndex, rowData) {
        return (0, _misc.formatCurrency)(rowData[column.id], { eyesable: column.eyesable });
      }
    }, column));
  },
  getDictValueColumn: function getDictValueColumn(dictions, column) {
    if (!Array.isArray(dictions)) {
      dictions = dictions.dictions || [];
    }
    return this.getColumn(babelHelpers.extends({
      width: 150,
      filterOption: {
        type: 'set',
        options: dictions
      },
      renderer: function renderer(cellValue, rowIndex, rowData) {
        return (0, _misc.safeAccessForDisplay)((0, _misc.getDictValue)(dictions, rowData[column.id]));
      }
    }, column));
  },
  getDatetimeColumn: function getDatetimeColumn(column, format) {
    return this.getColumn(babelHelpers.extends({
      width: 130,
      filterOption: {
        type: format === 1 || format == langCommon.format.date ? 'date' : 'datetime'
      },
      renderer: function renderer(cellValue, rowIndex, rowData) {
        return (0, _misc.formatDatetime)(rowData[column.id], format, (0, _misc.safeAccessForDisplay)());
      }
    }, column));
  }
};

exports.default = DataGrid;
});

define('webui-base/js/util/dialog', ['require', 'exports', 'module', 'react', 'react-dom', 'invariant', 'signals', 'bluebird', 'webui-base/js/util/misc', 'webui-base/js/util/alerts', 'webui-base/js/util/route', 'webui-base/js/util/error-boundary', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

var _invariant = require('invariant');

var _invariant2 = babelHelpers.interopRequireDefault(_invariant);

var _signals = require('signals');

var _signals2 = babelHelpers.interopRequireDefault(_signals);

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _misc = require('webui-base/js/util/misc');

var _alerts = require('webui-base/js/util/alerts');

var _alerts2 = babelHelpers.interopRequireDefault(_alerts);

var _route = require('webui-base/js/util/route');

var _route2 = babelHelpers.interopRequireDefault(_route);

var _errorBoundary = require('webui-base/js/util/error-boundary');

var _errorBoundary2 = babelHelpers.interopRequireDefault(_errorBoundary);

var _common = require('base/lang/' + G.LANG + '/common.json');

var _common2 = babelHelpers.interopRequireDefault(_common);

var containerDOM = $('\n    <div class="app-dialogs">\n      <button class="app-dialogs__btn-close" title="' + _common2.default.label.close + '" onclick="require(\'util\').Dialog.closeTop();">\n        <i class="fa fa-remove"></i>\n      </button>\n      <button class="app-dialogs__btn-close-all" title="' + _common2.default.label.closeAll + '" onclick="require(\'util\').Dialog.closeAll();">\n        <i class="fa fa-times-circle-o"></i>\n      </button>\n      <button class="app-dialogs__btn-toggle-right" title="' + _common2.default.label.collapse + '" onclick="require(\'util\').Dialog.collapse();">\n        <i class="fa fa-chevron-circle-right"></i>\n      </button>\n      <button class="app-dialogs__btn-toggle-left" title="' + _common2.default.label.expand + '" onclick="require(\'util\').Dialog.expand();">\n        <i class="fa fa-chevron-circle-left"></i>\n      </button>\n    </div>\n  ').appendTo(document.body)[0];
var dialogMap = {};
var dialogHistory = [];

function getClassName(name) {
  return name.replace(/\/+/g, '--');
}

function checkDialogActive() {
  var len = Object.keys(dialogMap).length;
  var active = len > 0;
  var body = $(document.body);
  if (len > 1) {
    body.addClass('app-dialog-multi-active');
  } else {
    body.removeClass('app-dialog-multi-active');
  }
  if (active) {
    var topDialog = dialogMap[$('.dialog--top').attr('data-name')];
    if (topDialog && topDialog.DialogComponent) {
      body.removeClass('app-dialog-full-active app-dialog-small-active');
      if (topDialog.DialogComponent.fullScreen) {
        body.addClass('app-dialog-full-active');
      } else if (topDialog.DialogComponent.small) {
        body.addClass('app-dialog-small-active');
      }
    }
    if (!body.hasClass('app-dialog-active')) {
      body.addClass('app-dialog-active');
      Dialog.onToggle.dispatch(true);
    } else {
      Dialog.onSwitch.dispatch();
    }
  } else {
    body.removeClass('app-dialog-full-active app-dialog-small-active app-dialog-all-collapsed');
    if (body.hasClass('app-dialog-active')) {
      body.removeClass('app-dialog-active');
      Dialog.onActive.dispatch(false);
    }
  }
}

var DialogManager = function () {
  function DialogManager(record, dialogDOM, DialogComponent, params) {
    var _this = this;

    babelHelpers.classCallCheck(this, DialogManager);
    this.name = '';
    this.dialogDOM = null;
    this.dialogComponent = null;
    this._onComplete = new _signals2.default();

    var self = this;
    this.record = record;
    this.name = record.name;
    this.dialogDOM = dialogDOM;
    this.DialogComponent = DialogComponent;
    var onComplete = function onComplete() {
      var _onComplete;

      return (_onComplete = _this.onComplete).dispatch.apply(_onComplete, arguments);
    };
    _reactDom2.default.render(_react2.default.createElement(_errorBoundary2.default, {
      dialog: true
    }, _react2.default.createElement(DialogComponent, {
      params: babelHelpers.extends({}, params),
      onComplete: onComplete,
      manager: this,
      ref: function ref(el) {
        self.dialogComponentInstance = el;
      }
    })), dialogDOM, function () {
      if (self.dialogComponentInstance && !self.dialogComponentInstance.isDialogComponent) {
        _alerts2.default.dev('Please decorate dialog "' + self.name + '" with "dialogComponent" decorator');
      }
    });
    $(this.dialogDOM).addClass('slide-in');
    dialogMap[this.name] = this;
    $(document.body).addClass('app-dialog-active--' + getClassName(this.name));
    checkDialogActive();
  }

  babelHelpers.createClass(DialogManager, [{
    key: 'back',
    value: function back() {
      _route2.default.push(this.backPath);
    }
  }, {
    key: 'close',
    value: function () {
      var _ref = babelHelpers.asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var onBeforeClose, onClose;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.dialogDOM) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                onBeforeClose = this.dialogComponentInstance && this.dialogComponentInstance.onBeforeClose;
                onClose = this.dialogComponentInstance && this.dialogComponentInstance.onClose;
                _context.t0 = !onBeforeClose;

                if (_context.t0) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return onBeforeClose(info);

              case 8:
                _context.t1 = _context.sent;
                _context.t0 = _context.t1 !== false;

              case 10:
                if (!_context.t0) {
                  _context.next = 13;
                  break;
                }

                this._destroy();
                onClose && onClose(info);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function close() {
        return _ref.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: '_destroy',
    value: function _destroy() {
      if (!this.dialogDOM) {
        return;
      }
      var dialogDOM = this.dialogDOM;
      $(dialogDOM).removeClass('slide-in');
      $('.app-dialogs__dialog:nth-last-child(2)').addClass('dialog--top');
      setTimeout(function () {
        _reactDom2.default.unmountComponentAtNode(dialogDOM);
        $(dialogDOM).remove();
      }, 300);
      this.onComplete.removeAll();
      this.onComplete = null;
      this.dialogDOM = null;
      this.DialogComponent = null;
      this.dialogComponentInstance = null;
      delete dialogMap[this.name];
      $(document.body).removeClass('app-dialog-active--' + getClassName(this.name));
      checkDialogActive();
    }
  }, {
    key: 'openTime',
    get: function get() {
      return this.record.openTime;
    }
  }, {
    key: 'onComplete',
    get: function get() {
      return this._onComplete || {
        remove: function remove() {}
      };
    },
    set: function set(onComplete) {
      this._onComplete = onComplete;
    }
  }, {
    key: 'backPath',
    get: function get() {
      var searchParams = (0, _misc.getSearchParams)();
      if (searchParams.dialogBack) {
        return searchParams.dialogBack;
      }
      var record = this.record;
      var res = Dialog.eachHistory(function (item) {
        if (item.locationPath != record.locationPath && item.locationSearch != record.locationSearch && item.stackSize === 0) {
          return false;
        }
      }) || record;
      return res.locationPath + res.locationSearch;
    }
  }]);
  return DialogManager;
}();

var Dialog = {
  /**
   * @param {String} name 'map/bar' eg
   * @param {Object} params optional params for dialog component
   * @return {Promise}
   */
  open: function open(name, params) {
    var _this2 = this;

    var locationPath = (0, _misc.getCurrentLocationPath)();
    var locationSearch = (0, _misc.getCurrentLocationSearch)();
    var openTime = new Date();
    return new _bluebird2.default(function (resolve, reject) {
      !(name.indexOf(':') > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Dialog.open: You must specify project name prefix!') : (0, _invariant2.default)(false) : void 0;
      var tmp = name.split(':'),
          appName = tmp[0],
          dialogName = tmp[1],
          req = appName == G.PROJECT_NAME ? require : (0, _misc.getAppRequire)(appName);
      req(['dialog/' + dialogName + '/main'], function (DialogComponent) {
        if (!DialogComponent) {
          return _alerts2.default.error(_common2.default.msg.svrErr);
        }
        if (_this2.isCollapsed) {
          _this2.closeAll();
        } else {
          _this2.close(name, { openSameName: true });
        }
        $(document.body).removeClass('app-dialog-all-collapsed');
        var prevRecord = dialogHistory[0];
        if (prevRecord && prevRecord.name == name && prevRecord.stackSize === 0) {
          locationPath = prevRecord.locationPath;
          locationSearch = prevRecord.locationSearch;
        }
        var record = {
          name: name,
          openTime: openTime,
          locationPath: locationPath,
          locationSearch: locationSearch,
          historySize: dialogHistory.length,
          stackSize: Object.keys(dialogMap).length
        };
        dialogHistory.unshift(record);
        $('.app-dialogs__dialog').removeClass('dialog--top');
        var dialogDOM = $('<div class="app-dialogs__dialog' + (DialogComponent.default.small ? ' app-dialogs__dialog--small' : DialogComponent.default.fullScreen ? ' app-dialogs__dialog--full' : '') + ' dialog--top dialog__' + getClassName(dialogName) + '" data-name="' + name + '"></div>').appendTo(containerDOM)[0];
        dialogDOM.offsetTop; // trigger reflow
        resolve(new DialogManager(record, dialogDOM, DialogComponent.default, params));
      }, function () {
        _alerts2.default.error(_common2.default.msg.svrErr);
        reject(new Error(_common2.default.msg.svrErr));
      });
    }).catch(function (err) {
      return _alerts2.default.error(err);
    });
  },
  close: function close(name, info) {
    var _this3 = this;

    if (typeof name == 'number') {
      var record = dialogHistory[name];
      name = record && record.name;
      setTimeout(function () {
        _this3.close(name, info);
      }, 0);
      return;
    } else if (Array.isArray(name)) {
      name.forEach(function (name) {
        return Dialog.close(name, info);
      });
      return;
    }
    !(name.indexOf(':') > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Dialog.close: You must specify project name prefix!') : (0, _invariant2.default)(false) : void 0;
    var dialog = dialogMap[name];
    if (dialog) {
      dialog.close(info);
    }
  },
  closeTop: function closeTop() {
    var name = $('.app-dialogs__dialog.dialog--top').attr('data-name');
    if (name) {
      this.close(name);
    }
  },
  closeAll: function closeAll(navigate) {
    for (var name in dialogMap) {
      var dialog = dialogMap[name];
      if (dialog instanceof DialogManager) {
        if (!navigate || !dialog.DialogComponent.keepAlivePaths || dialog.DialogComponent.keepAlivePaths.indexOf((0, _misc.getCurrentLocationPath)()) < 0) {
          dialog.close({ closeAll: true, navigate: navigate });
        }
      }
    }
  },


  get isCollapsed() {
    return $(document.body).hasClass('app-dialog-all-collapsed');
  },

  collapse: function collapse() {
    $(document.body).addClass('app-dialog-all-collapsed');
    Dialog.onToggle.dispatch(true);
  },
  expand: function expand() {
    $(document.body).removeClass('app-dialog-all-collapsed');
    Dialog.onToggle.dispatch(false);
  },
  eachHistory: function eachHistory(callback) {
    for (var record in dialogHistory) {
      if (callback && callback(record) === false) {
        return record;
      }
    }
  },


  onToggle: new _signals2.default(),
  onActive: new _signals2.default(),
  onSwitch: new _signals2.default()
};

_route2.default.onBeforeChange.add(function () {
  Dialog.collapse();
});

exports.default = Dialog;
});

define('webui-base/js/util/error-boundary', ['require', 'exports', 'module', 'react', 'prop-types', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var _common = require('base/lang/' + G.LANG + '/common.json');

var _common2 = babelHelpers.interopRequireDefault(_common);

var ErrorBoundary = function (_React$Component) {
  babelHelpers.inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    babelHelpers.classCallCheck(this, ErrorBoundary);

    var _this = babelHelpers.possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }

  babelHelpers.createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({ error: error, info: info });
      log.error(error);
      log.info(info);
    }
  }, {
    key: 'backToHome',
    value: function backToHome() {
      location.href = '/';
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      if (state.error) {
        return _react2.default.createElement(
          'div',
          { className: 'app-error-boundary' },
          _react2.default.createElement(
            'div',
            { className: 'result result-error' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' })
              ),
              _react2.default.createElement(
                'h4',
                null,
                _common2.default.msg.opps
              ),
              _react2.default.createElement(
                'p',
                null,
                state.error.message
              ),
              _react2.default.createElement(
                'p',
                null,
                props.dialog ? null : _react2.default.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.backToHome },
                  _common2.default.label.backToHome
                )
              )
            )
          )
        );
      }
      return props.children;
    }
  }]);
  return ErrorBoundary;
}(_react2.default.Component);

ErrorBoundary.propTypes = {
  dialog: _propTypes2.default.bool,
  children: _propTypes2.default.any
};

exports.default = ErrorBoundary;
});

define('webui-base/js/util/feed', ['require', 'exports', 'module', 'react', 'moment', 'webui-base/js/util/dialog', 'base/lang/' + G.LANG + '/common.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = babelHelpers.interopRequireDefault(_moment);

var _dialog = require('webui-base/js/util/dialog');

var _dialog2 = babelHelpers.interopRequireDefault(_dialog);

var _common = require('base/lang/' + G.LANG + '/common.json');

var _common2 = babelHelpers.interopRequireDefault(_common);

var Feeds = {
  getDisplayTimes: function getDisplayTimes(date) {
    date = (0, _moment2.default)(date);
    var now = (0, _moment2.default)(_moment2.default.now());
    if (date.format('x') > now.format('x')) {
      date = now;
    }
    var part1 = '';
    var part2 = date.format(_common2.default.format.time);
    if (now.format('x') - date.format('x') < 3600 * 1000 * 24 * 3) {
      if (now.format('x') - date.format('x') < 3600 * 1000 * 12 && now.date() == date.date()) {
        part1 = date.fromNow();
      } else if (now.date() == date.date()) {
        part1 = G.LANG == 'zh-CN' ? '今天' : 'Today';
      } else if (now.date() - date.date() === 1) {
        part1 = G.LANG == 'zh-CN' ? '昨天' : 'Yesterday';
      }
    }
    if (!part1) {
      if (now.year() == date.year()) {
        part1 = date.format(_common2.default.format.dateWithoutYear);
      } else {
        part1 = date.format(_common2.default.format.date);
      }
    }
    return [part1, part2];
  },
  getModelElement: function getModelElement(data, key, models) {
    var ele = void 0;
    var type = data.model;
    var name = data.real_name || data.name || data.code || data.plate || type;
    if (!data.id) {
      ele = _react2.default.createElement(
        'span',
        { key: key, className: 'model' },
        name
      );
    } else if (type == 'Statement') {
      ele = _react2.default.createElement(
        'span',
        { key: key, className: 'model' },
        _react2.default.createElement(
          'a',
          {
            href: 'javascript:void(0);',
            onClick: function onClick() {
              return _dialog2.default.open('webui-bss:financial-counting/bill-management/detail', data);
            }
          },
          name
        )
      );
    } else {
      ele = _react2.default.createElement(
        'span',
        { key: key, className: 'model' },
        name
      );
    }
    return ele;
  },
  getModels: function getModels(models) {
    var map = {};
    var list = models.map(function (data, i) {
      var type = data.model;
      map[type] = map[type] || [];
      map[type].push(data);
      return data;
    });
    return { map: map, list: list };
  },
  getModelElements: function getModelElements(models) {
    var _this = this;

    var map = {};
    var list = models.map(function (data, i, models) {
      var type = data.model;
      var ele = _this.getModelElement(data, i, models);
      map[type] = map[type] || [];
      map[type].push(ele);
      return ele;
    });
    return { map: map, list: list };
  },
  normalizeData: function normalizeData(data) {
    if (!data || data._normalized) {
      return data;
    }
    var supplement = void 0,
        optUser = void 0,
        optUsers = void 0,
        target = void 0,
        targets = void 0;
    try {
      supplement = data.additional_info ? JSON.parse(data.additional_info) : null;
    } catch (e) {
      supplement = null;
    }
    try {
      optUser = data.opt_user ? JSON.parse(data.opt_user) : [];
    } catch (e) {
      optUser = [];
    }
    try {
      target = data.target ? JSON.parse(data.target) : [];
    } catch (e) {
      target = [];
    }
    optUsers = Array.isArray(optUser) ? optUser : [optUser];
    targets = Array.isArray(target) ? target : [target];
    optUsers = optUsers.filter(function (item) {
      return item != null;
    });
    targets = targets.filter(function (item) {
      return item != null;
    });
    var executorModels = this.getModels(optUsers);
    var targetModels = this.getModels(targets);
    var executorElements = this.getModelElements(optUsers);
    var targetElements = this.getModelElements(targets);
    $.extend(data, {
      supplement: supplement,
      displayTimes: this.getDisplayTimes(data.created_at),
      ExecutorModels: executorModels.list,
      ExecutorModelsMap: executorModels.map,
      TargetModels: targetModels.list,
      TargetModelsMap: targetModels.map,
      ExecutorElements: executorElements.list,
      ExecutorElementsMap: executorElements.map,
      TargetElements: targetElements.list,
      TargetElementsMap: targetElements.map
    });
    data._normalized = true;
    return data;
  }
};

exports.default = Feeds;
});

define('webui-base/js/util/if-child-has-perm', ['require', 'exports', 'module', 'react', 'prop-types'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var IfChildHasPerm = function (_React$Component) {
  babelHelpers.inherits(IfChildHasPerm, _React$Component);

  function IfChildHasPerm(props) {
    babelHelpers.classCallCheck(this, IfChildHasPerm);

    var _this = babelHelpers.possibleConstructorReturn(this, (IfChildHasPerm.__proto__ || Object.getPrototypeOf(IfChildHasPerm)).call(this, props));

    _this.hasChild = false;
    _this.state = {
      renderChild: true
    };
    return _this;
  }

  babelHelpers.createClass(IfChildHasPerm, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var self = this;
      return {
        report: function report(has) {
          self.hasChild = self.hasChild || has;
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var context = this.context;
      if (!this.hasChild) {
        this.setState({ renderChild: false });
      }
      context.report && context.report(this.hasChild);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var children = props.children;
      return this.state.renderChild ? children : null;
    }
  }]);
  return IfChildHasPerm;
}(_react2.default.Component);

IfChildHasPerm.childContextTypes = {
  report: _propTypes2.default.func
};

IfChildHasPerm.contextTypes = {
  report: _propTypes2.default.func
};

exports.default = IfChildHasPerm;
});

define('webui-base/js/util/if-perm', ['require', 'exports', 'module', 'prop-types', 'webui-base/js/util/auth'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

var _auth = require('webui-base/js/util/auth');

var _auth2 = babelHelpers.interopRequireDefault(_auth);

function IfPerm(props, context) {
  var children = props.children;
  if (props.in) {
    if (typeof props.in == 'function') {
      if (props.in() === false) {
        context.report && context.report(false);
        return null;
      }
    } else {
      var projects = Array.isArray(props.in) ? props.in : [props.in];
      if (projects.every(function (project) {
        return project != G.PROJECT_NAME;
      })) {
        context.report && context.report(false);
        return null;
      }
    }
  }
  if (typeof props.has == 'function') {
    if (props.has()) {
      context.report && context.report(true);
      return children;
    }
  } else if (_auth2.default.Perm.has(props.has, props.all ? 'all' : '')) {
    context.report && context.report(true);
    return children;
  }
  context.report && context.report(false);
  return null;
}

IfPerm.propTypes = {
  in: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.func]),
  has: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.func]),
  all: _propTypes2.default.bool
};

IfPerm.contextTypes = {
  report: _propTypes2.default.func
};

exports.default = IfPerm;
});

define('webui-base/js/util/log', ['require', 'exports', 'module'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-console */

var log = function log() {
  if ("production" !== 'production') {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
};

log.error = log.err = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (console.error || console.log).apply(console, args);
};

var _arr = ['log', 'warn', 'info'];

var _loop = function _loop() {
  var type = _arr[_i];
  log[type] = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if ("production" !== 'production') {
      (console[type] || console.log).apply(console, args);
    }
  };
};

for (var _i = 0; _i < _arr.length; _i++) {
  _loop();
}

window.log = log;

exports.default = log;

/* eslint-enable no-console */
});

define('webui-base/js/util/message', ['require', 'exports', 'module', 'webui-base/js/util/feed'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feed = require('webui-base/js/util/feed');

var _feed2 = babelHelpers.interopRequireDefault(_feed);

var Message = {
  normalizeData: function normalizeData(data) {
    if (!data || data._normalized) {
      return data;
    }
    data = _feed2.default.normalizeData(data);
    data._normalized = true;
    return data;
  }
};

exports.default = Message;
});

define('webui-base/js/util/modal', ['require', 'exports', 'module', 'react', 'react-dom', 'base/lang/' + G.LANG + '/common.json', 'webui-base/js/util/route'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

var _common = require('base/lang/' + G.LANG + '/common.json');

var _common2 = babelHelpers.interopRequireDefault(_common);

var _route = require('webui-base/js/util/route');

var _route2 = babelHelpers.interopRequireDefault(_route);

var containerDOM = $('<div class="app-modals"></div>').appendTo(document.body)[0];
var modal = null;

var ConfirmComponent = function (_React$Component) {
  babelHelpers.inherits(ConfirmComponent, _React$Component);

  function ConfirmComponent() {
    babelHelpers.classCallCheck(this, ConfirmComponent);
    return babelHelpers.possibleConstructorReturn(this, (ConfirmComponent.__proto__ || Object.getPrototypeOf(ConfirmComponent)).apply(this, arguments));
  }

  babelHelpers.createClass(ConfirmComponent, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        'div',
        { className: 'modal fade modal--confirm' },
        _react2.default.createElement(
          'div',
          { className: 'modal-dialog modal-sm' },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            _react2.default.createElement(
              'div',
              { className: 'modal-body' },
              props.text
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal-footer' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-primary',
                  'data-dismiss': 'modal',
                  onClick: props.ok
                },
                _common2.default.label.ok
              ),
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-default',
                  'data-dismiss': 'modal',
                  onClick: props.cancel
                },
                _common2.default.label.cancel
              )
            )
          )
        )
      );
    }
  }]);
  return ConfirmComponent;
}(_react2.default.Component);

var Modal = {
  /**
   * @param {ReactComponent} ModalComponent
   * @param {Object} opt bootstrap modal options
   * @param {Object} props props for ModalComponent
   */
  open: function open(ModalComponent, opt, props) {
    _reactDom2.default.render(_react2.default.createElement(ModalComponent, props), containerDOM, function () {
      /* eslint-disable react/no-find-dom-node */
      modal = $(_reactDom2.default.findDOMNode(this)).on('hidden.bs.modal', function (evt) {
        _reactDom2.default.unmountComponentAtNode(containerDOM);
      });
      /* eslint-enable react/no-find-dom-node */
      opt = $.extend({ keyboard: true, backdrop: true }, opt);
      modal.modal(opt);
    });
  },
  close: function close() {
    if (modal) {
      modal.modal('hide');
      modal = null;
    }
  },
  confirm: function confirm(text) {
    var ok = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return 1;
    };
    var cancel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return 1;
    };

    Modal.open(ConfirmComponent, null, {
      text: text,
      ok: ok,
      cancel: cancel
    });
  }
};

_route2.default.onBeforeChange.add(function () {
  Modal.close();
});

exports.default = Modal;
});

define('webui-base/js/util/net', ['require', 'exports', 'module', 'signals', 'webui-base/js/util/ajax'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signals = require('signals');

var _signals2 = babelHelpers.interopRequireDefault(_signals);

var _ajax = require('webui-base/js/util/ajax');

var _ajax2 = babelHelpers.interopRequireDefault(_ajax);

/**
 * Check the network is idle or busy to optimize low priority tasks, such as preload modules to be used in the future
 * First check the status, if doesn't fulfill then use 'addOnce' to register the event to wait for the fulfillment.
 */

var status = ''; // '', 'idle' or 'busy'
var idleTaskQueue = [];
var queueToRef = null;

function startTasks() {
  if (!idleTaskQueue.length || queueToRef != null || status != 'idle') {
    return;
  }
  queueToRef = setTimeout(function run() {
    if (status == 'idle') {
      var task = idleTaskQueue.shift();
      if (idleTaskQueue.length) {
        queueToRef = setTimeout(run, 100);
      } else {
        queueToRef = null;
      }
      task && task();
    } else {
      queueToRef = null;
    }
  }, 500);
}

function stopTasks() {
  clearTimeout(queueToRef);
  queueToRef = null;
}

var Net = {
  get status() {
    return status;
  },

  /**
   * push task(function) into the queue of wait for network idle to run
   * @param {Array of Functions || Function} tasks
   * @return {Number} number of tasks pushed into the queue
   */
  pushIdleTasks: function pushIdleTasks(tasks) {
    if (Array.isArray(tasks)) {
      tasks = tasks.filter(function (task) {
        return typeof task == 'function';
      });
      idleTaskQueue = idleTaskQueue.concat(tasks);
      startTasks();
      return tasks.length;
    } else if (typeof tasks == 'function') {
      idleTaskQueue.push(tasks);
      startTasks();
      return 1;
    }
    return 0;
  },


  onIdle: new _signals2.default(),
  onBusy: new _signals2.default()
};

Net.onIdle.add(startTasks);
Net.onBusy.add(stopTasks);

// check status every 500ms
setTimeout(function check() {
  setTimeout(check, 500);
  var loadingCount = require.getLoadingCount() + _ajax2.default.getLoadingCount();
  var newStatus = loadingCount > 0 ? 'busy' : 'idle';
  if (newStatus != status) {
    status = newStatus;
    if (newStatus == 'idle') {
      Net.onIdle.dispatch();
    } else {
      Net.onBusy.dispatch();
    }
  }
}, 0);

// if 3s later the status is still init '' value, set it to 'idle'
setTimeout(function () {
  if (status == '') {
    status = 'idle';
    Net.onIdle.dispatch();
  }
}, 3000);

exports.default = Net;
});

define('webui-base/js/util/pdf', ['require', 'exports', 'module', 'bluebird', 'webui-base/js/util/modal'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _modal = require('webui-base/js/util/modal');

var _modal2 = babelHelpers.interopRequireDefault(_modal);

var _init = function init(pdfMake) {
  pdfMake.tableLayouts = pdfMake.tableLayouts || {};
  pdfMake.tableLayouts.noBorder = {
    hLineWidth: function hLineWidth() {
      return 0;
    },
    vLineWidth: function vLineWidth() {
      return 0;
    },
    paddingLeft: function paddingLeft() {
      return 0;
    },
    paddingRight: function paddingRight() {
      return 0;
    }
  };
  pdfMake.tableLayouts.inner = {
    hLineWidth: function hLineWidth(i, node) {
      if (i === 0 || i === node.table.body.length) {
        return 0;
      }
      return i === node.table.headerRows ? 2 : 1;
    },
    vLineWidth: function vLineWidth(i) {
      return 0;
    },
    hLineColor: function hLineColor(i) {
      return i === 1 ? '#777' : '#ccc';
    },
    paddingLeft: function paddingLeft(i) {
      return i === 0 ? 0 : 8;
    },
    paddingRight: function paddingRight(i, node) {
      return i === node.table.widths.length - 1 ? 0 : 8;
    }
  };
  _init = function init() {};
};

var Pdf = {
  genPdf: function genPdf(docDef) {
    return new _bluebird2.default(function (resolve, reject) {
      new _bluebird2.default(function (resolve, reject) {
        require(['pdfmake'], function (module) {
          resolve(module);
        }, function (err) {
          reject(err);
        });
      }).then(function (pdfMake) {
        _init(pdfMake);
        var pdf = pdfMake.createPdf(docDef);
        resolve({
          open: function open() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            _modal2.default.confirm('点击确定打开文件', function () {
              pdf.open.apply(pdf, args);
            });
          },
          print: function print() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            _modal2.default.confirm('点击确定打印文件', function () {
              pdf.print.apply(pdf, args);
            });
          },
          download: function download() {
            pdf.download.apply(pdf, arguments);
          }
        });
      }, reject);
    });
  }
};

exports.default = Pdf;
});

define('webui-base/js/util/route', ['require', 'exports', 'module', 'signals', 'base/lang/' + G.LANG + '/common.json', 'config', 'webui-base/js/util/alerts', 'webui-base/js/util/misc'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signals = require('signals');

var _signals2 = babelHelpers.interopRequireDefault(_signals);

var _common = require('base/lang/' + G.LANG + '/common.json');

var _common2 = babelHelpers.interopRequireDefault(_common);

var _config = require('config');

var _config2 = babelHelpers.interopRequireDefault(_config);

var _alerts = require('webui-base/js/util/alerts');

var _alerts2 = babelHelpers.interopRequireDefault(_alerts);

var _misc = require('webui-base/js/util/misc');

var lastChange = {
  init: true,
  time: window.performance.timing.navigationStart,
  route: {
    pathname: _config2.default.ROUTE_HISTORY_TYPE == 'browser' ? location.pathname : location.hash.replace(/^#?\/*/, '/')
  }
};

var Route = {
  get lastChange() {
    return lastChange;
  },

  normalizeIndexRoute: function normalizeIndexRoute(route) {
    return Object.assign({ _path: route.path }, _.omit(route, 'path'));
  },
  denormalizeIndexRoute: function denormalizeIndexRoute(route) {
    return Object.assign({ path: route._path }, _.omit(route, '_path'));
  },
  loadErrorHandler: function loadErrorHandler(err) {
    new Promise(function (resolve, reject) {
      require(['util'], function (module) {
        resolve(module);
      }, function (err) {
        reject(err);
      });
    }).then(function (Util) {
      Util.Alerts.error(_common2.default.msg.svrErr);
    });
  },
  to: function to(path, params) {
    if (params) {
      path = (0, _misc.appendQueryString)(path, params);
    }
    if (window.Skateboard) {
      return window.Skateboard.history.to(path);
    }
    return path;
  },
  push: function push(path, params, opt) {
    if (params) {
      path = (0, _misc.appendQueryString)(path, params);
    }
    if (window.ReactRouter) {
      window.ReactRouter.hashHistory.push(path);
    } else if (window.Skateboard) {
      if (path.indexOf(':back') >= 0) {
        var tmp = path.split(':back:');
        if (tmp.length > 1) {
          window.Skateboard.core.back(tmp[1]);
        } else {
          history.back();
        }
      } else {
        window.Skateboard.core.view(path, opt);
      }
    }
  },


  onBeforeChange: new _signals2.default(),
  onAfterChange: new _signals2.default()
};

if (window.ReactRouter) {
  var lastRoute = {};
  window.ReactRouter.hashHistory.listen(function (route) {
    if (route.action == 'POP' && route.pathname == lastRoute.pathname) {
      lastRoute = route;
      return;
    }
    lastRoute = route;
    lastChange = {
      time: new Date(),
      route: route
    };
    Route.onBeforeChange.dispatch(route);
  });
}

exports.default = Route;
});

define('webui-base/js/util/signal-bus', ['require', 'exports', 'module', 'signals'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signals = require('signals');

var _signals2 = babelHelpers.interopRequireDefault(_signals);

var signalMap = {};

var SignalBus = function SignalBus(name) {
  return signalMap[name];
};

SignalBus.create = function (names) {
  if (!Array.isArray(names)) {
    names = [names];
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;

      if (typeof name == 'string' && !signalMap[name]) {
        signalMap[name] = new _signals2.default();
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

exports.default = SignalBus;
});

define('webui-base/js/util/ui', ['require', 'exports', 'module', 'bluebird'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var UI = {};

var disabledLoadingTagsMap = {};

var loadingCount = 0;
var loadingTimeout = null;

var _initLoading = function initLoading() {
  var el = $('#app-loading-bar');
  if (!el.length) {
    $('<div id="app-loading-bar">loading...</div>').appendTo(document.body);
  }
  _initLoading = function initLoading() {
    return 0;
  };
};

var bootstrapPromise = new _bluebird2.default(function (resolve, reject) {
  UI.resolveBootstrap = resolve;
  UI.rejectBootstrap = reject;
});

UI.waitForBootstrap = function () {
  return bootstrapPromise;
};

UI.showLoading = function (tag) {
  if (disabledLoadingTagsMap[tag]) {
    return function () {};
  }
  loadingCount++;
  _initLoading();
  $('#app-loading-bar').addClass('is-loading');
  clearTimeout(loadingTimeout);
  loadingTimeout = setTimeout(function () {
    if (loadingCount) {
      loadingCount = 0;
      UI.hideLoading();
    }
  }, 30 * 1000);
  return function () {
    UI.hideLoading();
  };
};

UI.hideLoading = function () {
  loadingCount > 0 && loadingCount--;
  if (!loadingCount) {
    $('#app-loading-bar').removeClass('is-loading');
  }
};

UI.disableLoadingTag = function (tag) {
  disabledLoadingTagsMap[tag] = 1;
  return function () {
    disabledLoadingTagsMap[tag] = 0;
  };
};

// Add mark for non-production env
if (G.ENV != 'production') {
  $('<div class="env-mark ' + G.ENV + '">' + G.ENV.toUpperCase() + '</div>').appendTo(document.body);
}

exports.default = UI;
});